export const backendUrl = `https://onboardingbk.keelis.com/api`;
// export const backendUrl = `https://onboardingbk.egtech.in/api`;
// export const backendUrl = `http://localhost:5000/api`